import Navbar from '@/components/site/Navbar';
import Hero from '@/components/site/Hero';
import ChefsVoice from '@/components/site/ChefsVoice';
import Marquee from '@/components/site/Marquee';
import Pillars from '@/components/site/Pillars';
import Craft from '@/components/site/Craft';
import Catalog from '@/components/site/Catalog';
import Delivery from '@/components/site/Delivery';
import Inquiry from '@/components/site/Inquiry';
import Footer from '@/components/site/Footer';
import ProductSchema from '@/components/site/ProductSchema';
import JustOrderedTicker from '@/components/site/JustOrderedTicker';
import Seo from '@/components/Seo';

export default function Landing() {
  return (
    <div className="App relative">
      <Seo
        title="Premium Wholesale Butchery · Malaga WA"
        description="Halal-certified Australian beef, lamb, free-range poultry, wagyu and house-cured smallgoods. Cold-chain delivered across WA — export-registered to Malaysia, Singapore and the UAE. Est 2001."
        keywords="wholesale meat Perth, halal butcher Malaga, wagyu WA, grass-fed beef Australia, meat export Malaysia, meat export Singapore, meat export UAE, free-range chicken wholesale, lamb wholesale, restaurant meat supplier"
        path="/"
      />
      <ProductSchema />
      <Marquee />
      <Navbar />
      <main>
        <Hero />
        <ChefsVoice />
        <JustOrderedTicker />
        <div className="section-light section-light-first">
          <Catalog />
          <Craft />
          <Delivery />
          <Inquiry />
        </div>
      </main>
      <Footer />
    </div>
  );
}
